/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import ITemplateModel from 'apmui/master/Model';
import { IFormConfiguration, IFormField } from 'apmui/components/form/Model';

export function findField(form: IFormConfiguration, filedName: string): IFormField | undefined {
    return form.fields.filter((v: IFormField) => v.name === filedName)[0];
}

export function findForm(forms: IFormConfiguration[], formId: string): IFormConfiguration | undefined {
    return forms.filter((v: IFormConfiguration) => v.id === formId)[0];
}

export function isSessionVariable(v: string) {
    return !!v.match(/%{session.[^}]+}/);
}

const DEFAULT_LANDING_URI = '/';

export function getLandingUri(page: ITemplateModel) {
    const config = page.general.config;
    if (config.landingUriBase64 && !isSessionVariable(config.landingUriBase64)) {
        return config.landingUriBase64;
    } else if (config.landingUri && !isSessionVariable(config.landingUri)) {
        return config.landingUri;
    }
    return DEFAULT_LANDING_URI;
}
